import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import s from './s.module.less';

type Props = {
    stdListingCount: number;
    proListingCount: number;
};

const GrowthJourneyStepper: React.FC<Props> = ({ stdListingCount, proListingCount }) => {
    const step1Done = stdListingCount >= 5;
    const step2Done = proListingCount >= 5;
    const step3Done = step2Done;

    const step1Sub = `${stdListingCount} Provider${stdListingCount === 1 ? '' : 's'} ${stdListingCount === 1 ? 'is' : 'are'} listed`;
    const step2Sub = proListingCount > 0 ? `${proListingCount} of 5 on Pro-Listing` : 'Get on Pro-Listing to unlock';
    const step3Sub = step3Done ? 'Unlocked' : 'Earn 5+ providers on Pro-Listing to unlock';

    const progressWidth =
        step1Done && proListingCount === 0
            ? 'calc(50% - 32px)'
            : proListingCount > 0 && !step2Done
              ? `calc(50% - 32px + ${(Math.min(proListingCount, 5) / 5) * 50}%)`
              : step2Done
                ? 'calc(100% - 64px)'
                : '0';

    return (
        <div className={s.stepperCard}>
            <div className={s.stepperHeader}>
                <div className={s.stepperTitle}>Your Practice Growth Journey</div>
                <div className={s.stepperSubtitle}>
                    Add providers to Standard Listing, then opt them into Pro-Listing to unlock premium features.
                </div>
            </div>
            <div className={s.stepperTrack}>
                <div className={s.stepperLine} />
                <div className={s.stepperProgressLine} style={{ width: progressWidth }} />

                <div className={s.stepperStep}>
                    <div className={`${s.stepDot} ${step1Done ? s.stepDone : s.stepActive}`}>
                        {step1Done ? <CheckOutlined style={{ fontSize: 14 }} /> : '1'}
                    </div>
                    <div className={s.stepLabel}>Standard Listing</div>
                    <div className={s.stepSub}>{step1Sub}</div>
                </div>

                <div className={s.stepperStep}>
                    <div
                        className={`${s.stepDot} ${step2Done ? s.stepDone : proListingCount > 0 ? s.stepActive : s.stepPending}`}
                    >
                        {step2Done ? <CheckOutlined style={{ fontSize: 14 }} /> : '2'}
                    </div>
                    <div className={step2Done || proListingCount > 0 ? s.stepLabel : s.stepLabelPending}>
                        Pro-Listing <span style={{ fontWeight: 500 }}>(x5)</span>
                    </div>
                    <div className={step2Done || proListingCount > 0 ? s.stepSub : s.stepSubPending}>{step2Sub}</div>
                </div>

                <div className={s.stepperStep}>
                    <div className={`${s.stepDot} ${step3Done ? s.stepDone : s.stepPending}`}>
                        {step3Done ? <CheckOutlined style={{ fontSize: 14 }} /> : '3'}
                    </div>
                    <div className={step3Done ? s.stepLabel : s.stepLabelPending}>
                        {step3Done ? 'Premium Features' : 'Premium Features Locked'}
                    </div>
                    <div className={step3Done ? s.stepSub : s.stepSubPending}>{step3Sub}</div>
                </div>
            </div>
        </div>
    );
};

export default GrowthJourneyStepper;
